<div class="report">
    <div class="report__header">
        <div class="header__date">
            {{ receivedReport.smsdate | date : " HH:mm ,dd/MM/yyyy" }}
            <i class="fa-regular fa-calendar-lines"></i>
        </div>
        <h3 class="header__title">{{ receivedReport.smstype }}</h3>
        <button class="header__close" (click)="closeDialog()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="report__body">
        <p-table
            class="table report__table"
            [value]="smsdetail_reps"
            sortField="smsdate"
            [sortOrder]="-1"
            [paginator]="true"
            [alwaysShowPaginator]="false"
            [rows]="10"
            [first]="startFromReport"
        >
            <ng-template pTemplate="header">
                <tr class="table__row">
                    <th class="table-header__column">סיבה</th>
                    <th class="table-header__column">סטטוס</th>
                    <th class="table-header__column">הודעה</th>
                    <th class="table-header__column">טלפון</th>
                    <th class="table-header__column">שם</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-report>
                <tr class="table__row">
                    <td class="table__column">
                        <span class="column__text" [tooltip]="report.reason">{{ report.reason }}</span>
                    </td>
                    <td
                        class="table__column column__status"
                        [ngClass]="{
                            column__status_successful: report.status == 'נשלח',
                            column__status_failed: report.status == 'נכשל'
                        }"
                    >
                        {{ report.status }}
                        <i *ngIf="report.status == 'נשלח'" class="fa-solid fa-check"></i>
                        <i *ngIf="report.status == 'נכשל'" class="fa-solid fa-xmark"></i>
                    </td>
                    <td class="table__column">
                        <span class="column__text" [tooltip]="report.message">{{ report.message }}</span>
                    </td>
                    <td class="table__column">{{ report.phone }}</td>
                    <td class="table__column">
                        <span class="column__text" [tooltip]="report.name">{{ report.name }}</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <div *ngFor="let report of smsdetail_reps" class="report-card">
            <div class="report-card__row">
                <span class="report-card__value">{{ report.name }}</span>
                <span class="report-card__label">שם</span>
            </div>

            <div class="report-card__row">
                <span class="report-card__value">{{ report.phone }}</span>
                <span class="report-card__label">טלפון</span>
            </div>

            <div class="report-card__row">
                <span
                    class="report-card__value value__status"
                    [ngClass]="{
                        value__status_successful: report.status == 'נשלח',
                        value__status_failed: report.status == 'נכשל'
                    }"
                >
                    <i *ngIf="report.status == 'נשלח'" class="fa-solid fa-check"></i>
                    <i *ngIf="report.status == 'נכשל'" class="fa-solid fa-xmark"></i>
                    {{ report.status }}<span *ngIf="report.status == 'נכשל'">: {{ report.quantityfailed }}</span>
                </span>
                <span class="report-card__label">סטטוס</span>
            </div>

            <div *ngIf="report.status == 'נכשל'" class="report-card__row">
                <span class="report-card__value">{{ report.reason }}</span>
                <span class="report-card__label">סיבה</span>
            </div>
        </div>
    </div>
</div>
